import React, {useState, useEffect} from "react";
import styled from "styled-components";

import {getCalendar, getToday} from "utils/date";
import {getCommaNumber} from "utils/format";
import iconDrop from "assets/icons/icon_drop_black.svg";

import Block from "components/ui/Block";
import BarChart from "components/ui/chart/Bar";
import PopupCalendar from "components/ui/popup/Calendar";
import DatePicker from "components/ui/popup/DatePicker";
import VoucherSummaryInfo from "../voucher/SummaryInfo";



/**
 * [날짜 및 매출 개요]
 */

export const SummaryInfo = ({mode, data, color, isChart, isLoading, isError, onRefresh, onChange, ...props}) => {
	if(!data) data = {};

	const summaryInfo = data.summaryInfo || {};
	const chartInfo = data.chartInfo;
	const voucherInfo = data.voucherInfo;

	const [date, setDate] = useState((props.date) ? props.date : getToday());

	useEffect(() => {
		if(date && onChange) {
			onChange(date);
		}
	}, [date]);

	useEffect(() => {
		let date = props.date;
		if(!date) {
			switch(mode) {
				case "daily"	: date = new Date().getCalendar(); break;
				case "weekly"	: date = new Date().getStartDateInWeek().getCalendar(); break;
				case "monthly"	: date = new Date().getStartDateInMonth().getCalendar(); break;
			}
		}
		setDate(date);
	}, [props.date]);

	const eventHandler = {
		changeDate : (name, value) => {
			let date = undefined;
			switch(mode) {
				case "daily"	: date = value; break;
				case "weekly"	: date = new Date(value).getStartDateInWeek().getCalendar(); break;
				case "monthly"	: date = new Date(value).getStartDateInMonth().getCalendar(); break;
			}
			setDate(date);
		},
		changeYear : (name, value) => {
			const newDate = new Date(date);
			newDate.setFullYear(value);
			setDate(newDate.getCalendar());
		},
		changeMonth : (name, value) => {
			const newDate = new Date(date);
			newDate.setMonth(value - 1);
			setDate(newDate.getCalendar());
		},
		changeYearAndMonth : (value) => {
			setDate(value);
		}
	};

	const getDateInfo = () => {
		let text = props.title || "-";
		let year, month, day;

		switch(mode) {
			case "daily" :
				text = new Date(date).format("sm월 sd일 ww");
				break;

			case "weekly" :
				month = new Date(date).add(0, 0, 3).getMonth() + 1;
				const weekInMonth = new Date(date).getWeekInMonth();
				const startDate = new Date(date).format("zm.sd(sw)");
				const endDate = new Date(date).add(0, 0, 6).format("zm.sd(sw)");
				const period = ` · <span>${startDate}~${endDate}</span>`;
				text = `${month}월 ${weekInMonth}주차 ${period}`;
				break;

			case "monthly" :
				const getYearOptionList = () => {
					const year = new Date().getFullYear();
					const optionList = [];
					for(let i = year; i > year - 5; i--) {
						optionList.push({
							label : i + "년",
							value : i
						});
					}
					return optionList;
				};
				const getMonthOptionList = () => {
					const optionList = [];
					for(let i = 1; i <= 12; i++) {
						optionList.push({
							label : i + "월",
							value : i
						});
					}
					return optionList;
				};
				year = new Date(date).getFullYear();
				month = new Date(date).getMonth() + 1;
				return (
					<DatePicker mode="month" date={date} onChange={eventHandler.changeYearAndMonth}>
						<h4 className="icon">{year}년 {month}월</h4>
					</DatePicker>
				);

			case "receivable" :
				return (<h4>{props.title}</h4>);
		}

		const getCalendarDate = () => {
			return (mode == "weekly") ? new Date(date).add(0, 0, 3).getCalendar() : date;
		};

		// value={(mode == "daily") ? date : null}
		return (
			<PopupCalendar mode={mode} value={date} date={getCalendarDate()} onChange={eventHandler.changeDate}>
				<h4 className="icon" dangerouslySetInnerHTML={{__html : text}} />
			</PopupCalendar>
		);
	};

	return (
		<StyledBlock className={(color) ? color : null} onRefresh={onRefresh} isLoading={isLoading} isError={isError}>
			<div className="dateInfo">
				{getDateInfo()}
				<h2>{getCommaNumber(summaryInfo.totalSalesAmount)}원</h2>
			</div>
			{
				(chartInfo && isChart != false) ? (
					<div className="chartInfo">
						<BarChart data={chartInfo} height={150} />
					</div>
				) : null
			}
			{
				(voucherInfo) ? (
					<VoucherSummaryInfo data={voucherInfo} />
				) : null
			}
			{
				(Object.keys(summaryInfo).length > 1) ? (
					<div className="summaryInfo">
						<ul>
							<li>
								<div className="left">
									b.pay
									<em>{getCommaNumber(summaryInfo.bpaySalesCount)}건</em>
								</div>
								<div className="right">
									<var>{getCommaNumber(summaryInfo.bpaySalesAmount)}원</var>
								</div>
							</li>
							<li>
								<div className="left">
									현장판매
									<em>{getCommaNumber(summaryInfo.crmSalesCount)}건</em>
								</div>
								<div className="right">
									<var>{getCommaNumber(summaryInfo.crmSalesAmount)}원</var>
								</div>
							</li>
							<li>
								<div className="left">
									환불
									<em className="red">{getCommaNumber(summaryInfo.refundCount)}건</em>
								</div>
								<div className="right">
									<var>{getCommaNumber(summaryInfo.refundAmount * -1)}원</var>
								</div>
							</li>
						</ul>
					</div>
				) : null
			}
		</StyledBlock>
	);
};

const StyledBlock = styled(Block)`
&							{position:relative; padding:36px 24px; background-color:var(--lightBlue)}
&.red						{background-color:#fbf1f1}

.dateInfo					{text-align:center}
.dateInfo a					{display:block}
.dateInfo em				{display:inline-block; margin-top:5px; padding:4px 10px; background-color:var(--white); border-radius:20px; border:1px solid var(--border); font-size:var(--14px); color:var(--blue)}
.dateInfo em.red			{color:var(--red)}
.dateInfo h2				{margin-top:2px; font-size:1.75rem}
.dateInfo h4				{display:inline-flex; align-items:center; font-weight:500}
.dateInfo h4.icon			{padding-right:1em; background:url(${iconDrop}) no-repeat center right / 0.675em}
.dateInfo h4 span			{margin-left:0.25em; font-size:var(--16px); font-weight:400; color:var(--darkGray)}

.summaryInfo				{margin-top:20px; padding-top:20px; border-top:1px solid var(--border); color:#415c84}
.summaryInfo li				{display:flex; align-items:center; justify-content:space-between}
.summaryInfo li em			{margin-left:8px; padding:4px 8px; background-color:var(--white); border-radius:20px; border:1px solid #d4e1ff; font-size:var(--12px); font-weight:normal; color:#537bd8}
.summaryInfo li em.red		{border-color:#f3c4c4; color:#e76a6a}
.summaryInfo li .right		{text-align:right; font-size:var(--18px); font-weight:600}
.summaryInfo li + li		{margin-top:10px}

.chartInfo					{padding-top:8px}
`;

export default SummaryInfo;